import { UpdateEmployerContactsSubmissionData } from './update-employer-contacts-submission-data';
import { Deserializable } from '../../../../protocols/deserializable';

export class UpdateEmployerContactsSubmission implements Deserializable {
  public new!: UpdateEmployerContactsSubmissionData;
  public previous!: UpdateEmployerContactsSubmissionData;

  public onDeserialize(): void {
    if (!!this.new) {
      this.new = window.injector.Deserialize.instanceOf(UpdateEmployerContactsSubmissionData, this.new);
    }

    if (!!this.previous) {
      this.previous = window.injector.Deserialize.instanceOf(UpdateEmployerContactsSubmissionData, this.previous);
    }
  }
}
